import { Drawer, IconButton, XIcon } from "@au-schein-de/au-ui-library";
import type { ReactNode } from "react";

/**
 * The mobile picker surface (Figma 4075:38588): the same vaul Drawer the
 * product-list filters use — drag-to-dismiss, height driven by content —
 * restyled to the picker design (rounded 24px top, white header with a
 * gray-100 circular close button).
 */
export function PharmacyPickerMobileSheet({
	open,
	onOpenChange,
	title,
	closeLabel,
	children,
}: {
	open: boolean;
	onOpenChange: (open: boolean) => void;
	title: string;
	closeLabel: string;
	children: ReactNode;
}) {
	return (
		<Drawer.Root open={open} onOpenChange={onOpenChange}>
			<Drawer.Content
				className="max-h-[85dvh] overflow-hidden rounded-t-3xl border-none bg-white"
				data-testid="pharmacy-picker-content"
				aria-describedby={undefined}
			>
				<Drawer.Header className="shrink-0 bg-white px-4 pb-0 pt-4">
					<Drawer.Title className="text-h5 text-gray-700">{title}</Drawer.Title>
					<Drawer.Close asChild>
						<IconButton
							shape="circle"
							icon={<XIcon.Raw />}
							iconSize={5}
							aria-label={closeLabel}
							data-testid="pharmacy-picker-sheet-close"
						/>
					</Drawer.Close>
				</Drawer.Header>
				<div className="flex min-h-0 flex-1 flex-col overflow-hidden">
					{children}
				</div>
			</Drawer.Content>
		</Drawer.Root>
	);
}
